import React, { Component } from 'react';
import { ReactComponent as UserAltIcon } from '../assets/images/faceless.svg';
import { ReactComponent as BellIcon } from '../assets/images/bell.svg';
import { ReactComponent as ContactusIcon } from '../assets/images/contactus.svg';
import { ReactComponent as CloseIcon } from '../assets/images/close.svg';
import { ReactComponent as AIGLogo } from '../assets/images/Vendor/AIG/aig-logo.svg';
import { ReactComponent as DownArrow } from '../assets/images/arrow-cheveron-down.svg';
import {
    Popover,
    PopoverBody,
    PopoverHeader,
    Dropdown,
    DropdownItem,
    DropdownToggle,
    DropdownMenu,
    Navbar,
    NavbarToggler,
    NavbarBrand,
    Nav,
    NavItem,
    NavLink,
    Collapse
} from 'reactstrap';
import styles from '../components/Nav/NavHeader.module.css';
import classNames from 'classnames';
import { ReactComponent as LennoxLogo } from '../assets/images/Vendor/Lennox/lennox-logo.svg';
import { ReactComponent as ComfortShieldLogo } from '../assets/images/Vendor/Lennox/comfort-shield-logo.svg';
import CarrierLogo from '../assets/images/Vendor/Carrier/climate-shield-top-logo.png';
import RheemLogo from '../assets/images/Vendor/Rheem/protection-plus-logo.png';
import TraneLogo from '../assets/images/Vendor/Trane/ComfortSure-logo.svg';
import GELogo from '../assets/images/Vendor/GE/comfort-protect-logo.png';
import HDLogo from '../assets/images/Vendor/HomeDepot/HD_logo.svg';
import ICPLogo from '../assets/images/Vendor/ICP/comfort-promise-logo.svg';
import StaplesLogo from '../assets/images/Vendor/Staples/Staples_logo.svg';
import MCCLogo from '../assets/images/Vendor/MCC/MCC_Logo_new.svg';
import NordyneLogo from '../assets/images/Vendor/Nordyne/NGH-Logo.svg';
import MainlineLogo from '../assets/images/Vendor/MainlinePlus/mainline-plus-logo.png';
import StatusBadge from '../components/shared/StatusBadge/StatusBadge';
import NotificationInfo from './Notification/NotificationInfo';
import SnackBar from './shared/SnackBar/SnackBar';
import { SessionContext } from '../context/SessionContext';
import { DropDownInput } from '../components/inputs/DropDownInput';
import { Link } from 'react-router-dom';
import { getBrandContent, getProfileMenus } from '../components/BrandingWhiteLabel/BrandContent';
import ContactUsModal from '../components/Modals/ContactUsModal/ContactUsModal';
import { PaymentSource } from '../components/Global/PaymentConstants';
import { ReactComponent as HamgburgerIcon } from '../assets/images/Vendor/Trane/hamburgerMenu.svg';
import { getTranslation, connection } from '../components/Global/helpers';
import { LogoutModal } from '../components/Modals/LogoutModal';

const INACTIVITY_TIMEOUT = 10 * 60 * 1000; // 10 minutes in milliseconds
const WARNING_TIME = 2 * 60 * 1000; // Show warning 2 minutes before logout
const WARNING_DURATION = 2 * 60;

const events = ['mousedown', 'keypress', 'touchstart'];

export class Header extends Component {
    constructor(props) {
        super(props);

        this.state = {
            openProfileMenu: false,
            openNotifications: false,
            showNotification: [1, 2, 3, 4, 5],
            showSnackBar: true,
            dealer: 0,
            accountId: 0,
            showModal: false,
            isOpen: false,
            showContactUs: false,
            paymentPageStatus: null,
            cocContent: {},
            cocCertificateName: '',
            showWarning: false,
            countdown: WARNING_DURATION
        };

        this.timeoutRef = null;
        this.warningTimeoutRef = null;
        this.countdownIntervalRef = null;
        this.showWarningRef = { current: false };
    }

    connectionOff = () => {
        this.ping = () => {
            if (connection.state === 'Connected') {
                connection.invoke('Ping');
            }
        };

        connection.off('ShowInactivityModal');
        connection.off('ForceLogout');

        events.forEach((event) => {
            window.removeEventListener(event, this.handleActive);
        });

        events.forEach((event) => {
            window.removeEventListener(event, this.ping);
        });

        if (connection) {
            connection
                .stop()
                .then(console.log('Connection disconnected'))
                .catch((err) => console.error('SignalR stop failed ===>>> ', err));
        }

        if (this.timeoutRef) {
            clearTimeout(this.timeoutRef);
        }
        if (this.warningTimeoutRef) {
            clearTimeout(this.warningTimeoutRef);
        }
        if (this.countdownIntervalRef) {
            clearInterval(this.countdownIntervalRef);
        }
    };

    resetTimer = () => {
        if (this.showWarningRef.current) return;

        if (this.timeoutRef) {
            clearTimeout(this.timeoutRef);
        }
        if (this.warningTimeoutRef) {
            clearTimeout(this.warningTimeoutRef);
        }
        if (this.countdownIntervalRef) {
            clearInterval(this.countdownIntervalRef);
        }
        this.setState({ showWarning: false });
        this.warningTimeoutRef = setTimeout(() => {
            this.setState({ showWarning: true, countdown: WARNING_DURATION });

            this.countdownIntervalRef = setInterval(() => {
                this.setState((prevState) => {
                    if (prevState.countdown <= 1) {
                        clearInterval(this.countdownIntervalRef);
                        return { countdown: 0 };
                    }
                    return { countdown: prevState.countdown - 1 };
                });
            }, 1000);
        }, INACTIVITY_TIMEOUT - WARNING_TIME);

        this.timeoutRef = setTimeout(() => {
            this.handleLogout();
        }, INACTIVITY_TIMEOUT);
    };

    handleStayActive = () => {
        this.setState({ showWarning: false });
        this.resetTimer();
    };

    handleActive = () => {
        if (this.context.token !== '') {
            this.resetTimer();
        }
    };

    togglePopover = () => {
        this.setState({ openNotifications: !this.state.openNotifications });
    };

    toggleProfileMenu = () => {
        this.setState({ openProfileMenu: !this.state.openProfileMenu });
    };

    linkToProfile = (activeProfileTab, session) => {
        session.tabDispatch('ADD_TAB', {
            title: 'Profile',
            tabType: 'profile',
            activeProfileTab
        });
        this.toggleProfileMenu();
    };

    handleNotification = (notificationID) => {
        const { showNotification } = this.state;
        const pos = showNotification.indexOf(notificationID);
        if (pos > -1) {
            showNotification.splice(pos, 1);
        } else {
            showNotification.push(notificationID);
        }
        this.setState({ showNotification });
    };
    getLogos = (session) => {
        const account = this.context.accountName.toLowerCase();
        const { translationsHeader } = session;
        //For COC we are adding separate header driven by COC account
        const pathName = window.location?.pathname;
        if (this.context.cocHeader) {
            return (
                <div className={styles.logoBar}>
                    <div className={styles.leftWrapper}>
                        <span className={styles.iconWrapper}>
                            {!session.isAuthenticated() ? (
                                <a href='/login'>
                                    <img
                                        tabIndex={0}
                                        className={styles.logoImage}
                                        width={this.state.cocContent?.HeaderLogoWidth_style || '80px'}
                                        src={this.state.cocContent?.HeaderLogoURL_style}
                                    />
                                </a>
                            ) : (
                                <img
                                    tabIndex={0}
                                    className={styles.logoImage}
                                    width={this.state.cocContent?.HeaderLogoWidth_style || '80px'}
                                    src={this.state.cocContent?.HeaderLogoURL_style}
                                />
                            )}
                        </span>
                        <span className={styles.portalName}>{this.state.cocContent?.HeaderDescription_content}</span>
                    </div>
                </div>
            );
        }

        if (account === 'lennox') {
            return (
                <div className={styles.logoBar}>
                    <div className={styles.leftWrapper}>
                        {!session.isAuthenticated() ? (
                            <>
                                <a href='/login'>
                                    <ComfortShieldLogo className={styles.csLogo} />
                                    <LennoxLogo className={styles.lennoxIcon} />
                                </a>
                            </>
                        ) : (
                            <>
                                <ComfortShieldLogo className={styles.csLogo} />
                                <LennoxLogo className={styles.lennoxIcon} />
                            </>
                        )}
                        <span className={styles.portalName}>
                            {translationsHeader?.poweredByAig || 'Powered by AIG'}
                        </span>
                    </div>
                </div>
            );
        } else if (account === 'rheem') {
            return (
                <div className={styles.logoBar}>
                    <div className={styles.leftWrapper}>
                        {!session.isAuthenticated() ? (
                            <a href='/login'>
                                <img
                                    src={RheemLogo}
                                    alt='Rheem Logo'
                                    className={styles.rheemIcon}
                                />
                            </a>
                        ) : (
                            <img
                                src={RheemLogo}
                                alt='Rheem Logo'
                                className={styles.rheemIcon}
                                role='presentation'
                            />
                        )}
                        <span className={styles.portalName}>Powered by AIG</span>
                    </div>
                </div>
            );
        } else if (account === 'carrier') {
            return (
                <div className={styles.logoBar}>
                    <div className={styles.leftWrapper}>
                        {!session.isAuthenticated() ? (
                            <a href='/login'>
                                <img
                                    src={CarrierLogo}
                                    alt='Carrier Logo'
                                    className={styles.carrierIcon}
                                />
                            </a>
                        ) : (
                            <img
                                src={CarrierLogo}
                                alt='Carrier Logo'
                                className={styles.carrierIcon}
                                role='presentation'
                            />
                        )}
                        <span className={styles.portalName}>
                            {translationsHeader?.poweredByAig || 'Powered by AIG'}
                        </span>
                    </div>
                </div>
            );
        } else if (this.context.accountName.toLowerCase() === 'trane') {
            return (
                <div className={styles.logoBar}>
                    <div className={styles.leftWrapper}>
                        {!session.isAuthenticated() ? (
                            <a href='/login'>
                                <img
                                    src={TraneLogo}
                                    alt='Trane Logo'
                                    className={styles.traneIcon}
                                />
                            </a>
                        ) : (
                            <img
                                src={TraneLogo}
                                alt='Trane Logo'
                                className={styles.traneIcon}
                                role='presentation'
                            />
                        )}
                        <span className={styles.portalName}>
                            {translationsHeader?.poweredByAig || 'Powered by AIG'}
                        </span>
                    </div>
                </div>
            );
        } else if (this.context.accountName.toLowerCase() === 'ge') {
            return (
                <div className={styles.logoBar}>
                    <div className={styles.leftWrapper}>
                        {!session.isAuthenticated() ? (
                            <a href='/login'>
                                <img
                                    src={GELogo}
                                    alt='GE Logo'
                                    className={styles.geIcon}
                                />
                            </a>
                        ) : (
                            <img
                                src={GELogo}
                                alt='GE Logo'
                                className={styles.geIcon}
                                role='presentation'
                            />
                        )}
                        <span className={styles.portalName}>Powered by AIG</span>
                    </div>
                </div>
            );
        } else if (this.context.accountName.toLowerCase() === 'icp') {
            return (
                <div className={styles.logoBar}>
                    <div className={styles.leftWrapper}>
                        {!session.isAuthenticated() ? (
                            <a href='/login'>
                                <img
                                    src={ICPLogo}
                                    alt='ICP Logo'
                                    className={styles.icpIcon}
                                />
                            </a>
                        ) : (
                            <img
                                src={ICPLogo}
                                alt='ICP Logo'
                                className={styles.icpIcon}
                            />
                        )}
                        <span className={styles.portalName}>Powered by AIG</span>
                    </div>
                </div>
            );
        } else if (this.context.accountName.toLowerCase().replace(/ /g, '') === 'homedepot') {
            return (
                <div className={styles.logoBar}>
                    <div className={styles.leftWrapper}>
                        {!session.isAuthenticated() ? (
                            <a href='/login'>
                                <img
                                    src={HDLogo}
                                    alt='HD Logo'
                                    className={styles.hdIcon}
                                />
                            </a>
                        ) : (
                            <img
                                src={HDLogo}
                                alt='HD Logo'
                                className={styles.hdIcon}
                            />
                        )}
                        <span className={styles.portalName}>Powered by AIG</span>
                    </div>
                </div>
            );
        } else if (this.context.accountName.toLowerCase() === 'staples') {
            return (
                <div className={styles.logoBar}>
                    <div className={styles.leftWrapper}>
                        {!session.isAuthenticated() ? (
                            <a href='/login'>
                                <img
                                    src={StaplesLogo}
                                    className={styles.staplesIcon}
                                />
                            </a>
                        ) : (
                            <img
                                src={StaplesLogo}
                                className={styles.staplesIcon}
                            />
                        )}
                        <span className={styles.portalName}>Powered by AIG</span>
                    </div>
                </div>
            );
        } else if (this.context.accountName.toLowerCase() === 'mcc') {
            return (
                <div className={styles.logoBar}>
                    <div className={styles.leftWrapper}>
                        {!session.isAuthenticated() ? (
                            <a href='/login'>
                                <img
                                    src={MCCLogo}
                                    alt='MCC logo'
                                    className={styles.mccIcon}
                                />
                            </a>
                        ) : (
                            <img
                                src={MCCLogo}
                                alt='MCC logo'
                                className={styles.mccIcon}
                            />
                        )}
                        <span className={styles.portalName}>Warranty Administration Portal</span>
                    </div>
                </div>
            );
        } else if (this.context.accountName.toLowerCase() === 'nordyne') {
            return (
                <div className={styles.logoBar}>
                    <div className={styles.leftWrapper}>
                        {!session.isAuthenticated() ? (
                            <a href='/login'>
                                <img
                                    src={NordyneLogo}
                                    className={styles.nordyneIcon}
                                />
                            </a>
                        ) : (
                            <img
                                src={NordyneLogo}
                                className={styles.nordyneIcon}
                            />
                        )}
                        <span className={styles.portalName}>Powered by AIG</span>
                    </div>
                </div>
            );
        } else if (account === 'mainline') {
            return (
                <div className={styles.logoBar}>
                    <div className={styles.leftWrapper}>
                        {!session.isAuthenticated() ? (
                            <a href='/login'>
                                <img
                                    src={MainlineLogo}
                                    alt='Mainline Logo'
                                    className={styles.mainlineIcon}
                                />
                            </a>
                        ) : (
                            <img
                                src={MainlineLogo}
                                alt='Mainline Logo'
                                className={styles.mainlineIcon}
                                role='presentation'
                            />
                        )}
                        <span className={styles.portalName}>Powered by AIG</span>
                    </div>
                </div>
            );
        } else {
            return (
                <div className={styles.logoBar}>
                    <div className={styles.leftWrapper}>
                        <span className={styles.iconWrapper}>
                            {!session.isAuthenticated() ? (
                                <a href='/login'>
                                    <AIGLogo className={styles.aigIcon} />
                                </a>
                            ) : (
                                <AIGLogo className={styles.aigIcon} />
                            )}
                        </span>
                        {pathName.slice(1) !== 'coverageverification' ? (
                            <span className={styles.portalName}>
                                {translationsHeader?.servicePlanHub || 'Service Plan Hub'}
                            </span>
                        ) : (
                            <span className={styles.portalName}>Warranty Administration Portal</span>
                        )}
                    </div>
                </div>
            );
        }
    };

    componentWillUnmount() {
        this.connectionOff();
    }

    componentDidMount() {
        setTimeout(() => {
            this.setState({ showSnackBar: false });
        }, 6000);

        const session = this.context;

        if (session.token !== '') {
            connection.start();

            connection.on('ShowInactivityModal', () => {
                this.setState({ showWarning: true });
            });
            connection.on('ForceLogout', () => {
                this.handleLogout();
            });

            this.ping = () => {
                if (connection.state === 'Connected') {
                    connection.invoke('Ping');
                }
            };

            events.forEach((event) => {
                window.addEventListener(event, this.ping);
            });
            this.resetTimer();
        }
    }

    fetchHeaderContentWithFallback = async (names = []) => {
        for (const name of names) {
            if (!name) continue;

            try {
                const response = await getTranslation(`COC/BrandProvider/${name}_style.json`);
                if (response?.status === 200) {
                    return await response.json();
                }
            } catch (err) {}
        }

        return null;
    };

    async componentDidUpdate(prevState) {
        const { paymentGatewayStatus } = this.context;
        if (this.context.cocCertificateName !== this.state.cocCertificateName) {
            if (
                this.context?.certificateDetails?.certificateName?.toLowerCase() === 'hvac'
                || this.context?.certificateDetails?.certificateName?.toLowerCase() === 'hvacaftermarket'
            ) {
                const response = await getTranslation(
                    `COC/BrandProvider/${this.context.cocCertificateName}_style.json`
                );
                let data;
                if (response.status === 200) {
                    data = await response.json();
                } else {
                    const fallbackResponse = await getTranslation(`COC/BrandProvider/AIG_style.json`);
                    data = await fallbackResponse.json();
                }
                this.setState({
                    cocCertificateName: this.context.cocCertificateName,
                    cocContent: data
                });
            } else {
                const data = await this.fetchHeaderContentWithFallback([
                    this.context.cocCertificateName,
                    this.context?.certificateDetails?.programName,
                    this.context?.certificateDetails?.accountName
                ]);
                this.setState({
                    cocCertificateName: this.context.cocCertificateName,
                    cocContent: data
                });
            }
        }

        if (this.state.paymentPageStatus !== paymentGatewayStatus) {
            this.setState({
                paymentPageStatus: paymentGatewayStatus,
                showContactUs: !paymentGatewayStatus
            });
        }

        if (prevState.showWarning !== this.state.showWarning) {
            this.showWarningRef.current = this.state.showWarning;
        }
    }

    toggleModal = () => {
        this.setState({ showModal: !this.state.showModal });
    };

    handleContactUsClick = (session) => {
        if (session.isAuthenticated() && !this.context.needsToReacceptFlag()) {
            session.tabDispatch('ADD_TAB', {
                title: 'Contact Us',
                tabType: 'contactus'
            });
        } else {
            this.toggleModal();
        }
    };

    handleLogout = async () => {
        const { accountName, dangerouslyUpdateAuthState } = this.context;
        const accountNameLower = accountName.toLowerCase();

        this.setState({ showWarning: false });
        this.connectionOff();

        await fetch('authentication/logout');
        dangerouslyUpdateAuthState({
            isAuthenticated: false,
            dealerId: null
        });

        const brandsUsingLogout = ['lennox'];
        const redirectToLogout = brandsUsingLogout.indexOf(accountNameLower) > -1;

        if (!redirectToLogout) {
            window.location.href = '/login';
        }
    };

    toggleMenu = () => {
        this.setState({
            isOpen: !this.state.isOpen
        });
    };

    render() {
        const { openNotifications, openProfileMenu, showNotification, showContactUs } = this.state;
        const { accountName, paymentGatewayStatus } = this.context;
        const menuItems = getProfileMenus(accountName);
        const accountNameToLower = accountName?.toLowerCase();
        const session = this.context;
        const profile = session.getProfile();
        const { showWarning, countdown } = this.state;

        if (session.token !== '') {
            events.forEach((event) => {
                window.addEventListener(event, this.handleActive);
            });
        }

        return (
            <>
                <div className={classNames('container-fluid', 'p-0')}>
                    <Navbar
                        light
                        expand='sm'
                        role='navigation'
                        className={styles.NavbarHeader}
                    >
                        <NavbarBrand className={styles.logoContainer}>{this.getLogos(this.context)}</NavbarBrand>
                        {accountNameToLower !== 'staples' && (
                            <NavbarToggler
                                className={styles.NavMenuToggler}
                                onClick={this.toggleMenu}
                            >
                                <HamgburgerIcon />
                            </NavbarToggler>
                        )}
                        <Collapse
                            className={styles.NavItemContainer}
                            isOpen={this.state.isOpen}
                            navbar
                        >
                            {accountNameToLower !== 'staples' && (
                                <Nav className={styles.profileWrapper}>
                                    {this.context.isAuthenticated() && !this.context.needsToReacceptFlag() && (
                                        <NavItem>
                                            <span
                                                id='notificationInfo'
                                                className={styles.notification}
                                                type='button'
                                                onClick={() => this.togglePopover()}
                                            >
                                                <BellIcon className={styles.iconBell} />
                                                {this.context.notifications.length > 0 && (
                                                    <StatusBadge
                                                        color='danger'
                                                        content={this.context.notifications.length.toString()}
                                                    />
                                                )}
                                                <span className={styles.notificationText}>Notifications</span>
                                            </span>
                                        </NavItem>
                                    )}
                                    {showContactUs && (
                                        <NavItem
                                            className={styles.contactUsContainer}
                                            onClick={() => this.handleContactUsClick(this.context)}
                                        >
                                            <ContactusIcon className={styles.contactUsIcon} />
                                            <NavLink className={styles.contactUsLink}>
                                                <div className={styles.contactusText}>Contact Us</div>
                                            </NavLink>
                                        </NavItem>
                                    )}
                                    {this.state.showModal && <ContactUsModal isOpen={true} />}
                                    {this.context.isAuthenticated() && !this.context.needsToReacceptFlag() && (
                                        <NavItem className={styles.profileDropdownContainer}>
                                            <Dropdown
                                                isOpen={openProfileMenu}
                                                toggle={this.toggleProfileMenu}
                                            >
                                                <DropdownToggle
                                                    tag='span'
                                                    data-toggle='dropdown'
                                                    role='combobox'
                                                    aria-label='expands profile dropdown'
                                                >
                                                    <div
                                                        id='dropDownArrowDiv'
                                                        className='d-flex align-items-center'
                                                    >
                                                        <div id='userIcon'>
                                                            <UserAltIcon className={styles.iconUser} />
                                                        </div>
                                                        <div
                                                            id='dealerName'
                                                            className={styles.fontsizeDiv}
                                                        >
                                                            <span>{this.context.getProfile().dealerName}</span>
                                                        </div>
                                                        <div id='dropArrowIcon'>
                                                            <DownArrow className={classNames(styles.iconArrow)} />
                                                        </div>
                                                    </div>
                                                </DropdownToggle>
                                                <div className={styles.dropDownDiv}>
                                                    <DropdownMenu className={styles.dropdownDisplay}>
                                                        <DropdownItem
                                                            onClick={() => this.linkToProfile(1, this.context)}
                                                        >
                                                            My Profile
                                                        </DropdownItem>
                                                        {profile?.isAdvantageEligible
                                                            && menuItems?.advantagePrograms && (
                                                                <DropdownItem
                                                                    onClick={() => this.linkToProfile(2, this.context)}
                                                                >
                                                                    {`${getBrandContent(accountName).advantageProgramName} Preferences`}
                                                                </DropdownItem>
                                                            )}
                                                        {menuItems?.coveragePreferences && (
                                                            <DropdownItem
                                                                onClick={() => this.linkToProfile(3, this.context)}
                                                            >
                                                                Coverage Preferences
                                                            </DropdownItem>
                                                        )}
                                                        {menuItems?.billingPreferences && (
                                                            <DropdownItem
                                                                onClick={() => this.linkToProfile(4, this.context)}
                                                            >
                                                                Billing Preferences
                                                            </DropdownItem>
                                                        )}
                                                        {menuItems?.communication && (
                                                            <DropdownItem
                                                                onClick={() => this.linkToProfile(5, this.context)}
                                                            >
                                                                Communications
                                                            </DropdownItem>
                                                        )}
                                                        {menuItems?.security && (
                                                            <DropdownItem
                                                                onClick={() => this.linkToProfile(6, this.context)}
                                                            >
                                                                Security
                                                            </DropdownItem>
                                                        )}
                                                        {/*<DropdownItem onClick={this.toggleProfileMenu}>Update Password</DropdownItem>*/}
                                                        <DropdownItem onClick={this.handleLogout}>Logout</DropdownItem>
                                                    </DropdownMenu>
                                                </div>
                                            </Dropdown>
                                        </NavItem>
                                    )}
                                    {this.context.isAuthenticated() && !this.context.needsToReacceptFlag() && (
                                        <>
                                            <SnackBar
                                                numOfNotifications={this.context.notifications.length}
                                                showSnackBar={
                                                    this.state.showSnackBar && this.context.notifications.length > 1
                                                }
                                                onClickView={() =>
                                                    this.setState({ openNotifications: true, showSnackBar: false })
                                                }
                                            />
                                            <Popover
                                                placement='bottom'
                                                isOpen={openNotifications}
                                                toggle={() => this.togglePopover()}
                                                target='notificationInfo'
                                                trigger='focus'
                                                hideArrow={true}
                                                className={styles.notificationsPop}
                                            >
                                                <PopoverHeader className={styles.notificationPopHeader}>
                                                    <h3>Notifications</h3>
                                                    <span
                                                        className={styles.closeNotification}
                                                        type='button'
                                                        onClick={() => this.setState({ openNotifications: false })}
                                                    >
                                                        <CloseIcon />
                                                    </span>
                                                </PopoverHeader>
                                                <div className={styles.notificationBodyCover}>
                                                    {this.context.notifications.length == 0 ? (
                                                        <div className={styles.noNotifications}>
                                                            You have no new notifications
                                                        </div>
                                                    ) : (
                                                        <PopoverBody className={styles.notificationBody}>
                                                            {this.context.notifications.map((notif, key) => (
                                                                <NotificationInfo
                                                                    key={key}
                                                                    finalNotification={
                                                                        this.context.notifications.length == key + 1
                                                                    }
                                                                    message={notif.message}
                                                                    title={notif.title}
                                                                    dropTime={notif.created}
                                                                    hasClose={notif.hasClose}
                                                                    hasLink={
                                                                        notif.hasLink
                                                                        && (typeof this.context.tabs[
                                                                            this.context.activeTab - 1
                                                                        ] === 'undefined'
                                                                            || (typeof this.context.tabs[
                                                                                this.context.activeTab - 1
                                                                            ] !== 'undefined'
                                                                                && this.context.tabs[
                                                                                    this.context.activeTab - 1
                                                                                ].title !== notif.linkDestinationTitle
                                                                                && session.tabs[session.activeTab - 1]
                                                                                    .tabType !== 'serviceRequest'))
                                                                    }
                                                                    linkText={notif.linkText}
                                                                    show={true}
                                                                    badgeStatusID={notif.badgeStatusId}
                                                                    onLinkClick={() =>
                                                                        this.context.handleLinkClick(
                                                                            notif.linkDestinationTitle,
                                                                            notif.linkDestination,
                                                                            notif.linkText,
                                                                            notif.claimNumber,
                                                                            profile
                                                                        )
                                                                    }
                                                                    onDismiss={() =>
                                                                        this.context.handleDismissNotification(notif.id)
                                                                    }
                                                                />
                                                            ))}
                                                        </PopoverBody>
                                                    )}
                                                </div>
                                            </Popover>
                                        </>
                                    )}
                                </Nav>
                            )}
                        </Collapse>
                    </Navbar>
                </div>
                {showWarning && (
                    <LogoutModal
                        isOpen={showWarning}
                        handleStayActive={this.handleStayActive}
                        handleLogout={this.handleLogout}
                        countdown={countdown}
                    />
                )}
            </>
        );
    }
}
Header.contextType = SessionContext;
